module.exports = __webpack_public_path__ + "static/Scheme-PureKit-53b1a99a170d43663fb21d7c3f6bef90.png";